<template>
    <div class="section-posts2 section-posts-feed">
        <div class="navigations">
            <div class="container-list-avatar">
                <div class="list-avatar hide-scrollbar">
                    <Tooltip 
                        v-for="page in pagesSelected" 
                        :text="page.name"
                        :key="page.id"
                    >
                        <Avatar 
                            
                            :urlPicture="page.avatar" 
                            :typeNetwork="page.network" 

                            :checked="pageSelected && page.id == pageSelected.id"
                            @click="()=> selectPage(page)"
                        />
                    </Tooltip>
                </div>
            </div>
          
            <MainNavigation v-on="$listeners" :tabSelected="tabSelected"/>
        </div>
        <div class="content">
            <ListPosts 
                v-if="pageSelected && Object.keys(groupedItems).length" 
                :groups="groupedItems" 
                @selectEvent="handleEventClick"
                @changeDate="changeDate"
            />
            <PostNotFound v-else />
            <div class="instagram-app">
                <div class="container-phone">
                    <div class="actions">
                        <div class="container-legend">
                            <div class="legend">
                                <div class="item" v-for="status in ['scheduled', 'draft', 'posted']">
                                    <div class="circle-status card-status-background-primary-color" :class="status"></div>
                                    <p class="card-status-color" :class="status">{{$t(`dash.post.${status}`)}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="btns">
                            <div class="btn" @click="refreshInstagramData">
                                <i class="fa-solid fa-rotate"></i>
                            </div>
                            <div class="btn">
                                <i class="fa-solid fa-moon"></i>
                            </div>
                            <div class="btn">
                                <i class="fa-solid fa-download"></i>
                            </div>
                        </div>
                    </div>
                   
                    <Phone>
                        <InstagramInterface
                            :plannedItems="plannedItems"
                            :postedItems="postedItems"
                            :pinnedItems="pinnedItems" 
                            :statsProfile="statsProfile"
                            :page="pageSelected"
                            :loadingCard="this.configFetchItemPosted.isLoading || !this.configFetchItemPosted.isEnd"
                            @changeDate="changeDate"
                            @loadMorePostedItems="fetchItemPosted"
                            
                        />
                    </Phone>
                </div>
            </div>
        </div>

        <DrawerPost 
            v-if="eventSelected" 
            :event="eventSelected"
            @close="closeDrawer"
            @deletePost="handlerDeletePost"
        />
    </div>
</template>

<script>
import MainNavigation from './components/MainNavigation.vue'
import Phone from "./../postCreator/components/Phone.vue"
import Avatar from '../utils/avatar.vue';
import InstagramInterface from "./components/feed/InstagramInterface.vue"
import ListPosts from"./components/feed/ListPosts.vue"
import PostNotFound from "./components/feed/PostNotFound.vue"
import postMixins from '@/components/mixins/Posts.vue'
import DrawerPost from './components/drawer/index.vue'
import sectionPostMixins from './mixins/main.js'
import { event } from 'vue-analytics';
import { convertOldDraft, patchDraft } from './utils/draft.js';
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'

export default {
    
    components: {
        MainNavigation,
        Avatar,
        Phone,
        InstagramInterface,
        ListPosts,
        PostNotFound,
        DrawerPost,
        Tooltip
    },

    mixins: [postMixins, sectionPostMixins],

    props: {
        tabSelected: String
    },

    data() {
        return {
            pageSelected: null,

            plannedItems: [
                // { name: "John 1", id: 0, date: "2025-03-28T15:08:57.701Z", url: "https://picsum.photos/701", status : 'scheduled'},
                // { name: "Joao 2", id: 1, date: "2025-03-27T14:08:57.701Z", url: "https://picsum.photos/702", status : 'scheduled'},
                // { name: "Jean 3", id: 2, date: "2025-03-28T14:08:57.701Z", url: "https://picsum.photos/703", status : 'draft'},
                // { name: "Jonny 4", id: 3, date: "2025-03-28T11:08:57.701Z", url: "https://picsum.photos/704", status : 'draft'}, 
                // { name: "Guisepe 5", id: 4, date: "2025-03-27T14:08:57.701Z", url: "https://picsum.photos/705", status : 'draft'},
              
            ],

            postedItems: [
                // { name: "Hello 6", id: 5, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/706", status : 'posted'},
                // { name: "dism 7", id: 6, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/707", status : 'posted'},
                // { name: "Hello 6", id: 7, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/708", status : 'posted'},
                // { name: "dism 7", id: 8, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/709", status : 'posted'},
                // { name: "Hello 6", id: 9, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/710", status : 'posted'},
                // { name: "dism 7", id: 10, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/711", status : 'posted'},
                // { name: "Hello 6", id: 11, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/712", status : 'posted'},
                // { name: "dism 7", id: 12, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/713", status : 'posted'},
            ],

            pinnedItems: [
                { name: "Hello 6", id: 13, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/714", status : 'posted'},
            ],

            groupedItems: {}, // Objets regroupés par date
            mergedList: [],

            statsProfile: {
                followers_count: 0,
                follows_count: 0,
                media_count: 0,
            },

            configFetchItemPosted: {
                currentDate: null,
                tagsCursor: null,
                tagsBuffer: [],
                isEnd: false,
                isEndTags: false,
                isLoading: false
            },
            eventSelected : null,
        }
    },

    mounted () {
        this.pageSelected = this.pagesSelected[0]
        if (this.pageSelected){
            this.fetchData()
        }
    },
    methods: {
        async fetchData() {
            //recuperation des items posté
            this.postedItems = []
            this.pinnedItems = []
            this.plannedItems = []
            this.syncGroupedItems();

            if (!this.pageSelected) return
            const date = new Date();
            let currentStart = date.toISOString();
            date.setMonth(date.getMonth() + 12);
            let currentEnd = date.toISOString()

            const {body} = await this.postsByPagesV2(
                this.pageSelected.id,
                {
                    startDate: currentStart,
                    endDate: currentEnd,
                    statuses: 'scheduled,draft',
                    limit: 1000
                }
            )

            for (const post of body.posts) {

                if (post.page && post.page.length && post.page[0].story) continue

                const event = await this.buildEvent(post);
                if (!event || !['scheduled','draft'].includes(event.originalStatus) || event.type === 'story') continue

                const enclosure = event.image
                if (!enclosure) continue

                this.plannedItems.push({
                    ...event,
                    name: event.content,
                    content: event.content,
                    id: post.id,
                    date: event.date,
                    url: enclosure,
                    status : event.originalStatus,
                    format_date: new Date(event.date).toLocaleTimeString(this.$i18n.locale || 'fr-FR', {hour: '2-digit', minute: '2-digit'})
                })

            }

            this.sortItems()
            this.syncGroupedItems();

      
       
            
            try {
                this.statsProfile= {
                    followers_count:0,
                    follows_count:0,
                    media_count:0
                }

                this.configFetchItemPosted= {
                    currentDate: null,
                    tagsCursor: null,
                    isEnd: false,
                    isEndTags: false,
                    isLoading: false
                }

                const {body} = await this.getInstagramPageStatsProfile(this.pageSelected.id)
                
                if (body.success) {
                    this.statsProfile = {
                        followers_count: body.followers_count,
                        follows_count: body.follows_count,
                        media_count: body.media_count,
                    }
                    

                    const currentDate = new Date();
                    currentDate.setDate(1);

                    this.configFetchItemPosted = {
                        currentDate: currentDate,
                        isEnd: false,
                        isLoading: false
                    }

                
                    this.fetchItemPosted()
                    console.log('posts', this.postedItems, currentDate)
                }else{
                    throw new Error("Failed to fetch Instagram stats");
                }
                
            } catch (error) {
                this.configFetchItemPosted.isLoading = false
                this.configFetchItemPosted.isEnd = true
                console.log("Error fetching Instagram stats: ", error);
            }
            console.log('body',body)
        },

        async fetchItemPosted() {
            if (this.configFetchItemPosted.isLoading || this.configFetchItemPosted.isEnd) return
            const pageIdSelected = this.pageSelected.id
            this.configFetchItemPosted.isLoading = true
            const twoYearsAgo = new Date()
            twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2)

            const accumulated = []
            const seenIds = new Set(this.postedItems.map(p => p.id))

            while (
                pageIdSelected === this.pageSelected.id &&
                accumulated.length < 15 &&
                this.configFetchItemPosted.currentDate >= twoYearsAgo
            ) {
                const windowStart = new Date(this.configFetchItemPosted.currentDate.getFullYear(), this.configFetchItemPosted.currentDate.getMonth(), 1)
                const windowEnd = new Date(this.configFetchItemPosted.currentDate.getFullYear(), this.configFetchItemPosted.currentDate.getMonth() + 1, 1)
                const windowStartMs = windowStart.getTime()
                const windowEndMs = windowEnd.getTime()

                // 1. Fetch this month's own posts
                try {
                    const { body } = await this.getPostsFromRS(
                        pageIdSelected,
                        Math.floor(windowStartMs / 1000),
                        Math.floor(windowEndMs / 1000)
                    )
                    if (body.success && body.posts && body.posts.data.length > 0) {
                        for (const post of body.posts.data) {
                            if (!seenIds.has(post.id)) {
                                seenIds.add(post.id)
                                accumulated.push({
                                    name: post.caption,
                                    id: post.id,
                                    date: post.timestamp,
                                    url: post.full_picture,
                                    status: 'posted',
                                    type: {CAROUSEL_ALBUM: 'carousel', IMAGE: '', VIDEO: 'reel'}[post.media_type],
                                    is_shared_to_feed: post.is_shared_to_feed
                                })
                            }
                        }
                    } else if (!body.success) {
                        break
                    }
                } catch (error) {
                    console.error('Error fetching media:', error)
                    break
                }

                // Advance month pointer for next outer iteration
                this.configFetchItemPosted.currentDate.setMonth(this.configFetchItemPosted.currentDate.getMonth() - 1)

                // 2. Fetch collabs for this window.
                //    Items older than the window go into tagsBuffer instead of being discarded —
                //    future scrolls drain the buffer as the window advances, so nothing is lost.
                if (!this.configFetchItemPosted.isEndTags) {
                    // Drain any buffered items that now fall within this window
                    const stillBuffered = []
                    for (const p of (this.configFetchItemPosted.tagsBuffer || [])) {
                        const ts = new Date(p.date).getTime()
                        if (ts >= windowStartMs && ts < windowEndMs && !seenIds.has(p.id)) {
                            seenIds.add(p.id)
                            accumulated.push(p)
                        } else if (ts < windowStartMs) {
                            stillBuffered.push(p)
                        }
                    }
                    this.configFetchItemPosted.tagsBuffer = stillBuffered

                    // Keep fetching pages until we get items older than this window
                    while (this.configFetchItemPosted.tagsBuffer.length === 0 && !this.configFetchItemPosted.isEndTags) {
                        try {
                            const { body } = await this.getInstagramTagsPage(pageIdSelected, this.configFetchItemPosted.tagsCursor)
                            if (!body || !body.success) break

                            const newBuffer = []
                            for (const p of (body.posts || [])) {
                                const ts = new Date(p.timestamp).getTime()
                                const mapped = {
                                    name: p.caption, id: p.id, date: p.timestamp,
                                    url: p.thumbnail_url || p.media_url,
                                    status: 'posted', collab: true,
                                    type: {CAROUSEL_ALBUM: 'carousel', IMAGE: '', VIDEO: 'reel'}[p.media_type],
                                    is_shared_to_feed: p.is_shared_to_feed
                                }
                                if (ts >= windowStartMs && ts < windowEndMs && !seenIds.has(p.id)) {
                                    seenIds.add(p.id)
                                    accumulated.push(mapped)
                                } else if (ts < windowStartMs) {
                                    newBuffer.push(mapped)
                                }
                            }

                            this.configFetchItemPosted.tagsBuffer = newBuffer
                            this.configFetchItemPosted.tagsCursor = body.nextCursor || null
                            if (!body.nextCursor) this.configFetchItemPosted.isEndTags = true
                        } catch (e) {
                            console.error('Error fetching collabs:', e)
                            break
                        }
                    }
                }
            }

            if (pageIdSelected !== this.pageSelected.id) {
                this.configFetchItemPosted.isLoading = false
                return
            }

            if (this.configFetchItemPosted.currentDate < twoYearsAgo) {
                this.configFetchItemPosted.isEnd = true
            }

            accumulated.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
            this.postedItems = [...this.postedItems, ...accumulated]
            this.configFetchItemPosted.isLoading = false
        },

        async refreshInstagramData() {
            this.configFetchItemPosted= {
                currentDate: null,
                tagsCursor: null,
                isEnd: false,
                isEndTags: false,
                isLoading: false
            }
            this.postedItems = []

            const {body} = await this.getInstagramPageStatsProfile(this.pageSelected.id)
            
            if (body.success) {
                this.statsProfile = {
                    followers_count: body.followers_count,
                    follows_count: body.follows_count,
                    media_count: body.media_count,
                }
                

                const currentDate = new Date();
                currentDate.setDate(1);

                this.configFetchItemPosted = {
                    currentDate: currentDate,
                    isEnd: false,
                    isLoading: false
                }

                this.fetchItemPosted()
                console.log('posts', this.postedItems, currentDate)
            }
        },

        selectPage(page) {
            this.pageSelected = page
            this.fetchData()
        },

        async changeDate({postId, newDate, itemsSort, refreshGroupedItems = true}) {
            console.log("changeDate", {postId, newDate, itemsSort, refreshGroupedItems})
            if (itemsSort) {
                this.plannedItems = itemsSort
            }else{
                const indexPost = this.plannedItems.findIndex(item => item.id == postId)
                if (indexPost) {
                    this.plannedItems[indexPost].date = newDate
                    this.sortItems()
                }
            }

            if (refreshGroupedItems) {
                this.syncGroupedItems()
            }

            const event = this.plannedItems.find(item => item.id == postId)
            if (event) {
                this.$set(event, 'format_date', new Date(event.date).toLocaleTimeString(this.$i18n.locale || 'fr-FR', {hour: '2-digit', minute: '2-digit'}))
                
                if (event.originalPost) {
                    const dateInstance = new Date(newDate)
                    const {body} = await this.updatePostScheduledDate(event.originalPost, {
                        date: newDate,
                        hour: dateInstance.getHours(), 
                        minute: dateInstance.getMinutes(), 
                        scheduledDate: newDate,
                    }, false, false)
                }
             
            }
        },

        sortItems() {
            this.plannedItems.sort((a, b) => new Date(b.date) - new Date(a.date));
        },

        syncGroupedItems(sortItems = false) {
            if (sortItems) this.sortItems()
            this.groupedItems = {}
            this.plannedItems.forEach(item => {
                const date = item.date.split('T')[0]
                if (!this.groupedItems[date]) this.groupedItems[date] = []
                this.groupedItems[date].push(item)
            });

            //trier chaque group par date
            // Object.keys(this.groupedItems).forEach(date => {
            //     this.groupedItems[date].sort((a, b) => new Date(a.date) - new Date(b.date));
            // });
           
        },

        syncMergeList() {

        },

         async handleEventClick(event) {
          
            if (event.draft && !event.draft.saveAllFormData) {

                const pages =  event.originalPost.page && event.originalPost.page[0].posts_multipages ? 
                    event.originalPost.page[0].posts_multipages.map(({page}) => page) : 
                    [event.page.id]

                const draft = patchDraft(await convertOldDraft(JSON.parse(JSON.stringify(event.draft)), pages))
                
                event.draft = draft                
            }
            this.eventSelected = event
        },
        
        closeDrawer() {
            this.eventSelected = null
        },
    },

    watch: {
        pagesSelected: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!newValue.length) {
                    this.$emit('changeTab','planner')
                }
            }
        }
    },

    computed: {

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]).filter(page => page.network == 'instagram');
        }
    }
} 
</script>